import axios from 'axios'
import { BASE_URL } from '@/service_urls'

const demoDOH = {
    checkStandAlonePQR: ({ queryString }) => axios.get(`${BASE_URL}/pqr_checker/?${queryString}`)
}
export default demoDOH